import { useEffect } from "react"

import { Modal } from "antd"
import { useDispatch, useSelector } from "react-redux"
import { useSearchParams } from "react-router-dom"

import Icon from "../../../../../Icon"
import { getRequestVerifiInform } from "../../redux/requestsVerifiInform.thunks"
import RequestInfo from "./RequestInfo"

const RequestInfoModal = () => {
  const dispatch = useDispatch()
  const { requestVerifiInform, requestVerifiInformFetching } = useSelector(
    (state) => state.requestsVerifiInform
  )

  const state = useSelector((state) => state.requestsVerifiInform)
  const [params, setParams] = useSearchParams()
  const openRequestId = params.get("open_request")

  const closeModal = () => {
    params.delete("open_request")
    setParams(params)
  }

  useEffect(() => {
    if (!openRequestId) return
    dispatch(getRequestVerifiInform({ id: openRequestId }))
  }, [openRequestId])

  return (
    <Modal
      open={!!openRequestId}
      classNames={{ content: "clear-bg" }}
      title={"Request details"}
      centered={true}
      closeIcon={<Icon type="cross_small" />}
      closable={true}
      onCancel={closeModal}
      destroyOnClose
      width={600}
      okText={"Got it"}
      onOk={closeModal}
      loading={requestVerifiInformFetching}
      footer={(_, { OkBtn }) => <OkBtn />}
      getContainer={() => document.getElementById("main-layout")}
    >
      <RequestInfo request={requestVerifiInform} />
    </Modal>
  )
}

export default RequestInfoModal
